import { render, staticRenderFns } from "./pbrCenterForm.vue?vue&type=template&id=be746f88&scoped=true"
import script from "./pbrCenterForm.vue?vue&type=script&lang=js"
export * from "./pbrCenterForm.vue?vue&type=script&lang=js"
import style0 from "./pbrCenterForm.vue?vue&type=style&index=0&id=be746f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be746f88",
  null
  
)

export default component.exports